import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'delete'

export default class OspreyOffersTagsRemove extends BaseAction {
    constructor(dataKey) {
        const id = 'f975bcc7-6d9b-431d-bcfd-9ad00aa95ffd'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeTagFromOffer(params) {
        const { offerId, tagId } = params

        this.path = `/${resource}/${offerId}/tags/${tagId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-tags-remove.js